var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4425 25L41.5175 28.235M27.5 32.245L34.745 34.185M50.78 31.6175C49.2675 37.255 48.5125 40.075 46.8 41.9025C45.4487 43.3454 43.7001 44.3554 41.775 44.805C41.5333 44.8617 41.2875 44.905 41.0375 44.935C38.75 45.2175 35.9575 44.47 30.8775 43.11C25.24 41.5975 22.42 40.8425 20.5925 39.13C19.1491 37.778 18.1391 36.0285 17.69 34.1025C17.12 31.6625 17.875 28.845 19.3875 23.2075L20.68 18.3775L21.29 16.115C22.4275 11.95 23.1925 9.65748 24.66 8.08998C26.0116 6.64798 27.7602 5.63883 29.685 5.18998C32.125 4.61998 34.945 5.37498 40.585 6.88748C46.22 8.39748 49.04 9.15248 50.8675 10.8625C52.3113 12.2151 53.3214 13.9656 53.77 15.8925C54.1725 17.6175 53.9125 19.5325 53.1925 22.5",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17952 41.6183C9.68952 47.2558 10.447 50.0758 12.1595 51.9033C13.5108 53.3462 15.2594 54.3562 17.1845 54.8058C19.6245 55.3733 22.4445 54.6183 28.0845 53.1083C33.7195 51.5983 36.5395 50.8433 38.367 49.1308C39.596 47.9796 40.5144 46.5366 41.037 44.9358M21.2895 16.1133C20.4112 16.3416 19.4403 16.5999 18.377 16.8883C12.7395 18.3983 9.91952 19.1533 8.09202 20.8633C6.64825 22.2159 5.63815 23.9664 5.18952 25.8933C4.78702 27.6183 5.04702 29.5333 5.76702 32.5008",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.5299616530ec87ce3cffc860e534b763.svg";
export { ForwardRef as ReactComponent };